module.exports = __webpack_public_path__ + "img/ic-chat.e309883.gif";